import {Language} from 'yougile-lang'
import {DataObjectId, UserUITheme} from 'yougile-model'

/**
 * List of events that can be tracked.
 */

export enum TrackingEvent {
  performanceStats = 'Performance:Stats',

  statsFrontPageIsOpenInBrowser = 'Stats:FrontPageIsOpenInBrowser',
  statsFrontPageIsOpenInDesktop = 'Stats:FrontPageIsOpenInDesktop',

  pageNavigate = 'Page:Navigate',
  pageNavigateFromProjectsMenu = 'Page:NavigateFromProjectsMenu',

  chatPanelCloseMobileAppBanner = 'ChatPanel:CloseMobileAppBanner',
  chatPanelShowMobileAppBanner = 'ChatPanel:ShowMobileAppBanner',

  landingPageOpened = 'Landing:PageOpened',
  landingSignInButtonClick = 'Landing:SignInButtonClick',
  landingOpenProductPageButtonClick = 'Landing:OpenProductPageButtonClick',

  landingRequestCall = 'Landing:RequestCall',
  landingRequestCallAboutBox = 'Landing:RequestCallAboutBox',
  landingRequestCallAboutPlatform = 'Landing:RequestCallAboutPlatform',

  landingDownloadPresentationAboutPlatform = 'Landing:DownloadPresentationAboutPlatform',
  landingDownloadPlatformInstallationFile = 'Landing:DownloadPlatformInstallationFile',
  landingDownloadBoxInstallationFile = 'Landing:DownloadBoxInstallationFile',

  landingQrCodeRedirectToAndroid = 'Landing:QrCodeRedirectToAndroid',
  landingQrCodeRedirectToIos = 'Landing:QrCodeRedirectToIos',
  landingQrCodeRedirectToWeb = 'Landing:QrCodeRedirectToWeb',

  landingOpenVacancyPopupFrom = 'Landing:OpenVacancyPopupFrom',
  landingClickOpenHrTgButtonFromPopup = 'Landing:ClickOpenHrTgButtonFromPopup',
  landingClickOpenHHButtonFromPopup = 'Landing:ClickOpenHHButtonFromPopup',
  projectManagementCourseLikeButtonClick = 'ProjectManagementCourse:LikeButtonClick',
  projectManagementCourseDislikeButtonClick = 'ProjectManagementCourse:DislikeButtonClick',

  regFormClick = 'RegForm:Click',
  regFormSuccess = 'RegForm:Success',
  regFormError = 'RegForm:Error',
  regFormExists = 'RegForm:Exists',
  regFormGoogleClick = 'RegForm:GoogleClick',
  regFormGoogleError = 'RegForm:GoogleError',

  regPageCompleteInvite = 'RegPage:CompleteInvite',
  regPageCompleteRegister = 'RegPage:CompleteRegister',

  taskCreate = 'Task:Create',
  taskSendMessage = 'Task:SendMessage',
  taskEditDescription = 'Task:EditDescription',
  taskEditDescriptionFail = 'Task:EditDescriptionFail',
  taskEditSubtasks = 'Task:EditSubtasks',
  taskMoveOnBoard = 'Task:MoveOnBoard',
  taskArchive = 'Task:Archive',
  taskArchiveAllInColumn = 'Task:ArchiveAllInColumn',
  taskArchiveAllCompleted = 'Task:ArchiveAllCompleted',
  taskComplete = 'Task:Complete',
  taskUncompleted = 'Task:Uncompleted',
  taskChangeColor = 'Task:ChangeColor',

  accountDarkModeTry = 'Account:DarkModeTry',
  accountDarkModeChange = 'Account:DarkModeChange',

  chatPanelOpen = 'ChatPanel:Open',
  chatPanelClose = 'ChatPanel:Close',
  chatPanelBack = 'ChatPanel:Back',
  chatPanelClickTask = 'ChatPanel:ClickTask',
  chatPanelClickUser = 'ChatPanel:ClickUser',
  chatPanelOpenDirectList = 'ChatPanel:OpenDirectList',
  chatPanelOpenTaskList = 'ChatPanel:OpenTaskList',
  chatPanelChangeFilter = 'ChatPanel:ChangeFilter',
  chatPanelCreateGroupChat = 'ChatPanel:CreateGroupChat',

  groupChatSendMessage = 'GroupChat:SendMessage',
  groupChatEditSave = 'GroupChat:EditSave',
  groupChatEditClick = 'GroupChat:EditClick',
  groupChatSubscribe = 'GroupChat:Subscribe',
  groupChatUnsubscribe = 'GroupChat:Unsubscribe',
  groupChatCreate = 'GroupChat:Create',

  leftPanelOpen = 'leftPanel:Open',
  leftPanelExpandPanelButtonClick = 'leftPanel:ExpandPanelButtonClick',
  leftPanelCollapsePanelButtonClick = 'leftPanel:CollapsePanelButtonClick',
  leftPanelProfileClick = 'leftPanel:ProfileClick',
  leftPanelMyTasksClick = 'leftPanel:MyTasksClick',
  leftPanelOtherTasksClick = 'leftPanel:OtherTasksClick',
  leftPanelMyCompanyClick = 'leftPanel:MyCompanyClick',
  leftPanelExpandChatListClick = 'leftPanel:ExpandChatListClick',
  leftPanelCollapseChatListClick = 'leftPanel:CollapseChatListClick',
  leftPanelProjectClick = 'leftPanel:ProjectClick',
  leftPanelCreateNewGroupChatClick = 'leftPanel:CreateNewGroupChatClick',
  leftPanelEventListClick = 'leftPanel:EventListClick',
  leftPanelReportsClick = 'leftPanel:ReportsClick',
  leftPanelBilling = 'leftPanel:Billing',
  leftPanelSupportClick = 'leftPanel:SupportClick',
  leftPanelChangeCompanyClick = 'leftPanel:ChangeCompanyClick',
  leftPanelCompaniesSettingsClick = 'leftPanel:CompaniesSettingsClick',
  leftPanelOpenDirectList = 'leftPanel:OpenDirectList',
  leftPanelOpenDirectChat = 'leftPanel:OpenDirectChat',
  leftPanelOpenGroupChat = 'leftPanel:OpenGroupChat',

  directSendMessage = 'Direct:SendMessage',
  directInvite = 'Direct:Invite',
  directInviteError = 'Direct:InviteError',
  directInviteSuccess = 'Direct:InviteSuccess',

  chatMarkUnread = 'Chat:MarkUnread',
  chatMarkImportant = 'Chat:MarkImportant',

  chatUploadFile = 'Chat:UploadFile',
  chatEditQuicklink = 'Chat:EditQuicklink',
  chatFollowQuicklink = 'Chat:FollowQuicklink',
  chatChangeWhoNotified = 'Chat:ChangeWhoNotified',
  chatEditMessage = 'Chat:EditMessage',
  chatDeleteMessage = 'Chat:DeleteMessage',

  chatEmojiUsed = 'Chat:EmojiUsed',
  chatMentioned = 'Chat:Mentioned',
  chatReplied = 'Chat:Replied',
  chatOpenDirectFromUserList = 'Chat:OpenDirectFromUserList',

  projectSearch = 'Project:Search',
  projectCreate = 'Project:Create',
  projectSettingsChangePrefix = 'ProjectSettings:ChangePrefix',

  boardCreate = 'Board:Create',
  // boardOpenChat = 'Board:OpenChat',

  columnCreate = 'Column:Create',
  columnCreateMirror = 'Column:CreateMirror',

  stickerCreate = 'Sticker:Create',
  stickerDropOnTask = 'Sticker:DropOnTask',
  stickerDropOnColumn = 'Sticker:DropOnColumn',

  stickerPanelApplyFilteringByTheAssignedSticker = 'StickerPanel:ApplyFilteringByTheAssignedSticker',
  stickerPanelApplyFilteringByTheDeadlineSticker = 'StickerPanel:ApplyFilteringByTheDeadlineSticker',
  stickerPanelApplyFilteringByTheStatusSticker = 'StickerPanel:ApplyFilteringByTheStatusSticker',
  stickerPanelApplyFilteringByTheTimeIntervalSticker = 'StickerPanel:ApplyFilteringByTheTimeIntervalSticker',

  checklistDropOnTask = 'Checklist:DropOnTask',

  companyCreate = 'Company:Create',
  companyCreateSuccess = 'Company:CreateSuccess',
  companyCreateError = 'Company:CreateError',
  companyCreateAuto = 'Company:CreateAuto',
  companyInvite = 'Company:Invite',
  companyInviteSuccess = 'Company:InviteSuccess',
  companyInviteError = 'Company:InviteError',

  companySettingsUseOldIdOn = 'CompanySettings:UseOldIdOn',
  companySettingsUseOldIdOff = 'CompanySettings:UseOldIdOff',

  companySettingsUseNewGanttOn = 'CompanySettings:UseNewGanttOn',
  companySettingsUseNewGanttOff = 'CompanySettings:UseNewGanttOff',

  scriptsOpen = 'Scripts:Open',
  scriptsCreate = 'Scripts:Create',

  diffsBranch100K = 'Diffs:Branch100K',
  diffsBranch500K = 'Diffs:Branch500K',
  diffsBranch1M = 'Diffs:Branch1M',
  diffsBranch5M = 'Diffs:Branch5M',

  billingLeftMenuClick = 'Billing:LeftMenuClick',
  billingLeftMenuFooterClick = 'Billing:LeftMenuFooterClick',
  billingPermissionsWarnClick = 'Billing:PermissionsWarnClick',
  billingChangeLicenseClick = 'Billing:ChangeLicenseClick',
  billingToggleRecurrent = 'Billing:ToggleRecurrent',
  billingPayCardClick = 'Billing:PayCardClick',
  billingPayCardSuccess = 'Billing:PayCardSuccess',
  billingPayCardCancel = 'Billing:PayCardCancel',
  billingPayCardError = 'Billing:PayCardError',
  billingInvoiceClick = 'Billing:InvoiceClick',
  billingInvoiceSuccess = 'Billing:InvoiceSuccess',
  billingInvoiceError = 'Billing:InvoiceError',

  statisticsLeftMenuClick = 'Statistics:LeftMenuClick',
  statisticsBillingWarnClick = 'Statistics:BillingWarnClick',
  statisticsVideoClick = 'Statistics:VideoClick',

  siteBannerClick = 'Site:BannerClick',

  byUserClick = 'ByUser:Click',
  byTimeClick = 'ByTime:Click',
  timelineClick = 'Timeline:Click',
  reportsClick = 'Reports:Click',
  reportClick = 'Report:Click',
  reportsSwitchToTheGanttChartView = 'Reports:SwitchToTheGanttChartView',

  reportColumnCreateReportColumn = 'ReportColumn:CreateReportColumn',
  reportColumnCreateMirroredTaskViaReportColumn = 'ReportColumn:CreateMirroredTaskViaReportColumn',
  reportColumnMoveSubtaskViaReportColumn = 'ReportColumn:MoveSubtaskViaReportColumn',

  myTasksClick = 'MyTasks:Click',
  // myTasksCompleteFromBoard = 'MyTasks:CompleteFromBoard',
  // myTasksUncompleteFromBoard = 'MyTasks:UncompleteFromBoard',
  // myTasksComplete = 'MyTasks:Complete',
  // myTasksUncomplete = 'MyTasks:Uncomplete',
  myTasksToNew = 'MyTasks:ToNew',
  myTasksToCurrent = 'MyTasks:ToCurrent',
  myTasksToBacklog = 'MyTasks:ToBacklog',
  myTasksAllToNew = 'MyTasks:AllToNew',
  myTasksAllToCurrent = 'MyTasks:AllToCurrent',
  myTasksAllToBacklog = 'MyTasks:AllToBacklog',
  myTasksShowInfo = 'MyTasks:ShowInfo',
  myTasksGoToBoard = 'MyTasks:GoToBoard',

  myTasksCompleteTaskViaMyTaskSection = 'MyTasks:CompleteTaskViaMyTaskSection',
  myTasksCompletePrivateTaskViaMyTaskPage = 'MyTasks:CompletePrivateTaskViaMyTaskPage',
  taskCompleteTaskViaBoard = 'Task:CompleteTaskViaBoard',
  taskCompleteTaskViaRightPanel = 'Task:CompleteTaskViaRightPanel',
  taskCompleteTaskViaMultiActionsMenu = 'Task:CompleteTaskViaMultiActionsMenu',

  taskOpenTaskRightPanelViaBoard = 'Task:OpenTaskRightPanelViaBoard',
  myTasksOpenTaskViaMyTaskSection = 'MyTasks:OpenTaskViaMyTaskSection',

  myTasksCreateFromLeftMenu = 'MyTasks:CreateFromLeftMenu',
  myTasksCreatePrivate = 'MyTasks:CreatePrivate',
  myTasksChangeStarred = 'MyTasks:ChangeStarred',
  myTasksCreateTaskViaMyTaskPage = 'MyTasks:CreateTaskViaMyTaskPage',
  myTasksCreatePrivateTaskViaMyTaskPage = 'MyTasks:CreatePrivateTaskViaMyTaskPage',
  myTasksCreateTaskAtTheBottomViaMyTaskPage = 'MyTasks:CreateTaskAtTheBottomViaMyTaskPage',
  myTasksCreatePrivateTaskAtTheBottomViaMyTaskPage = 'MyTasks:CreatePrivateTaskAtTheBottomViaMyTaskPage',
  myTasksChangeTheOrderOfTasksInOpenTasksList = 'MyTasks:ChangeTheOrderOfTasksInOpenTasksList',
  myTasksSettingAnyFilterInTheOpenTasksList = 'MyTasks:SettingAnyFilterInTheOpenTasksList',
  myTasksCreateListViaMyTaskPage = 'MyTasks:CreateListViaMyTaskPage',
  myTasksCreatePrivateListViaMyTaskPage = 'MyTasks:CreatePrivateListViaMyTaskPage',
  myTasksDeleteListViaMyTaskPage = 'MyTasks:DeleteListViaMyTaskPage',
  myTasksDeletePrivateListViaMyTaskPage = 'MyTasks:DeletePrivateListViaMyTaskPage',
  myTasksMoveListViaMyTaskPage = 'MyTasks:MoveListViaMyTaskPage',
  myTasksMoveTaskBetweenListsViaMyTaskPage = 'MyTasks:MoveTaskBetweenListsViaMyTaskPage',
  myTasksMovePrivateTaskToAnotherPrivateList = 'MyTasks:MovePrivateTaskToAnotherPrivateList',

  rightPanelResized = 'RightPanel:Resized',

  rightPanelPersonalChatStarredOn = 'RightPanel:PersonalChatStarredOn',
  rightPanelPersonalChatStarredOff = 'RightPanel:PersonalChatStarredOff',
  rightPanelGroupChatStarredOn = 'RightPanel:GroupChatStarredOn',
  rightPanelGroupChatStarredOff = 'RightPanel:GroupChatStarredOff',
  rightPanelTaskChatStarredOn = 'RightPanel:TaskChatStarredOn',
  rightPanelTaskChatStarredOff = 'RightPanel:TaskChatStarredOff',
  rightPanelTaskComplete = 'RightPanel:TaskComplete',
  rightPanelTaskUncompleted = 'RightPanel:TaskUncompleted',
  myTasksTaskChatStarredOn = 'MyTasks:TaskChatStarredOn',
  myTasksTaskChatStarredOff = 'MyTasks:TaskChatStarredOff',
  myTasksFavouriteTaskChatStarredOn = 'MyTasks:FavouriteTaskChatStarredOn',
  myTasksFavouriteTaskChatStarredOff = 'MyTasks:FavouriteTaskChatStarredOff',

  depsEdit = 'Deps:Edit',
  depsSetPosition = 'Deps:SetPosition',

  shareGuestVisit = 'Share:GuestVisit',
  shareUserVisit = 'Share:UserVisit',
  shareChangeName = 'Share:ChangeName',
  shareGuestSendMessage = 'Share:GuestSendMessage',
  shareUserSendMessage = 'Share:UserSendMessage',
  shareCreateBoard = 'Share:CreateBoard',
  shareChangeBg = 'Share:ChangeBg',

  subtasksCreateNew = 'Subtasks:CreateNew',
  subtasksAddExistent = 'Subtasks:AddExistent',
  subtasksAddExistentParent = 'Subtasks:AddExistentParent',
  subtasksOpenTree = 'Subtasks:OpenTree',
  subtasksOpenList = 'Subtasks:OpenList',
  subtasksMovingSubtaskToTheBoard = 'Subtasks:MovingSubtaskToTheBoard',
  subtasksMovingSubtaskToTheBoardViaDrag = 'Subtasks:MovingSubtaskToTheBoardViaDrag',
  subtasksMovingSubtaskToTheBoardViaMenu = 'Subtasks:MovingSubtaskToTheBoardViaMenu',

  sitePriceCalculatorInteraction = 'Site:PriceCalculatorInteraction',
  sitePriceRoiInteraction = 'Site:PriceRoiInteraction',

  trelloBannerClick = 'Trello:BannerClick',
  trelloBannerHide = 'Trello:BannerHide',
  trelloClick = 'Trello:Click',
  trelloImport = 'Trello:Import',
  extensionsBannerClick = 'Extensions:BannerClick',
  extensionsBannerHide = 'Extensions:BannerHide',

  reactionChange = 'Reaction:Change',

  stickerSettingsShowTimerView_Enable = 'StickerSettings:ShowTimerView_Enable',
  stickerSettingsShowTimerView_Disable = 'StickerSettings:ShowTimerView_Disable',
  stickerSettingsRequireDeadlineWhenTaskCreated_Enable = 'StickerSettings:RequireDeadlineWhenTaskCreated_Enable',
  stickerSettingsRequireDeadlineWhenTaskCreated_Disable = 'StickerSettings:RequireDeadlineWhenTaskCreated_Disable',
  stickerSettingsSuggestDeadlineWhenTaskCreated_Enable = 'StickerSettings:SuggestDeadlineWhenTaskCreated_Enable',
  stickerSettingsSuggestDeadlineWhenTaskCreated_Disable = 'StickerSettings:SuggestDeadlineWhenTaskCreated_Disable',
  stickerSettingsOpenStickersEditorPopup = 'StickerSettings:OpenStickersEditorPopup',

  stickerPanelExpandButtonClick = 'StickerPanel:ExpandButtonClick',
  stickerPanelCollapseButtonClick = 'StickerPanel:CollapseButtonClick',
  stickerPanelOpenTimetrackingStatistics = 'StickerPanel:OpenTimetrackingStatistics',

  multiActionsWithTasksSelectWithHotKey = 'MultiActionsWithTasks:SelectWithHotKey',
  multiActionsWithTasksSelectWithTaskMenu = 'MultiActionsWithTasks:SelectWithTaskMenu',
  multiActionsWithTasksCheckAllInColumn = 'MultiActionsWithTasks:CheckAllInColumn',
  multiActionsWithTasksUnCheckAllInColumn = 'MultiActionsWithTasks:UnCheckAllInColumn',
  multiActionsWithTasksExit = 'MultiActionsWithTasks:Exit',
  multiActionsWithTasksCompleteTasks = 'MultiActionsWithTasks:CompleteTasks',
  multiActionsWithTasksCompleteTasksCancel = 'MultiActionsWithTasks:CompleteTasksCancel',
  multiActionsWithTasksArchive = 'MultiActionsWithTasks:Archive',
  multiActionsWithTasksUnArchive = 'MultiActionsWithTasks:UnArchive',
  multiActionsWithTasksMove = 'MultiActionsWithTasks:Move',
  multiActionsWithTasksDelete = 'MultiActionsWithTasks:Delete',

  taskDescriptionOpenDescriptionTab = 'TaskDescription:OpenDescriptionTab',
  taskDescriptionFullScreenOpen = 'TaskDescription:FullScreenOpen',
  taskDescriptionFullScreenEdit = 'TaskDescription:FullScreenEdit',
  taskDescriptionEdit = 'TaskDescription:Edit',
  taskDescriptionFullScreenSave = 'TaskDescription:FullScreenSave',
  taskDescriptionSave = 'TaskDescription:Save',
  taskDescriptionOpenHistory = 'TaskDescription:OpenHistory',
  taskDescriptionHistoryVersionRecovery = 'TaskDescription:HistoryVersionRecovery',

  screencastClick = 'Screencast:Click',
  screencastStart = 'Screencast:Start',
  screencastSend = 'Screencast:Send',
  screencastDownload = 'Screencast:Download',
  screencastCancel = 'Screencast:Cancel',
  screencastRecordingFinished = 'Screencast:RecordingFinished',
  screencastPause = 'Screencast:Pause',
  screencastResume = 'Screencast:Resume',

  taskCoverUploadCoverViaChat = 'TaskCover:UploadCoverViaChat',
  taskCoverDownloadViaChat = 'TaskCover:DownloadViaChat',
  taskCoverUploadCoverViaBoardTaskMenu = 'TaskCover:UploadCoverViaBoardTaskMenu',
  taskCoverRemoveCoverViaBoardTaskMenu = 'TaskCover:RemoveCoverViaBoardTaskMenu',
  taskMirrorCreate = 'TaskMirror:Create',

  taskCoverUploadCoverViaRightPanelTaskMenu = 'TaskCover:UploadCoverViaRightPanelTaskMenu',
  taskCoverRemoveCoverViaRightPanelTaskMenu = 'TaskCover:RemoveCoverViaRightPanelTaskMenu',

  boardSettingsOpenStickersListViaPopup = 'BoardSettings:OpenStickersListViaPopup',
  boardSettingsOpenStickersLibraryViaPopup = 'BoardSettings:OpenStickersLibraryViaPopup',
  boardSettingsOpenStickersListViaBoard = 'BoardSettings:OpenStickersListViaBoard',
  boardSettingsOpenStickersListViaStickerMenu = 'BoardSettings:OpenStickersListViaStickerMenu',
  boardSettingsOpenStickersLibraryViaBoard = 'BoardSettings:OpenStickersLibraryViaBoard',
  boardSettingsOpenMovementTemplatesViaCardMenu = 'BoardSettings:OpenMovementTemplatesViaCardMenu',
  boardSettingsOpenMovementTemplatesCreateViaCardMenu = 'BoardSettings:OpenMovementTemplatesCreateViaCardMenu',
  boardSettingsTaskTemplatesCreateViaColumnMenu = 'BoardSettings:TaskTemplatesCreateViaColumnMenu',
  boardSettingsTaskTemplatesListViaColumnMenu = 'BoardSettings:TaskTemplatesListViaColumnMenu',
  boardSettingsOpenMovementTemplatesViaBoardSettings = 'BoardSettings:OpenMovementTemplatesViaBoardSettings',
  boardSettingsOpenStickerSettings = 'BoardSettings:OpenStickerSettings',
  boardSettingsOpenStickerEditorViaStickersList = 'BoardSettings:OpenStickerEditorViaStickersList',
  boardSettingsOpenStickerEditorViaStickersLibrary = 'BoardSettings:OpenStickerEditorViaStickersLibrary',
  boardSettingsEditCustomStickerViaBoard = 'BoardSettings:EditCustomStickerViaBoard',
  boardSettingsCustomBackgroundEnable = 'BoardSettings:CustomBackgroundEnable',
  boardSettingsCustomBackgroundDisable = 'BoardSettings:CustomBackgroundDisable',

  boardSettingsEnableAutoTaskCover = 'BoardSettings:EnableAutoTaskCover',
  boardSettingsDisableAutoTaskCover = 'BoardSettings:DisableAutoTaskCover',
  boardSettingsSetAutoTaskCoverColumns = 'BoardSettings:SetAutoTaskCoverColumns',
  boardSettingsShowCounterInColumnOn = 'BoardSettings:ShowCounterInColumnOn',
  boardSettingsShowCounterInColumnOff = 'BoardSettings:ShowCounterInColumnOff',
  boardSettingsAutoCompleteOn = 'BoardSettings:AutoCompleteOn',
  boardSettingsAutoCompleteOff = 'BoardSettings:AutoCompleteOff',
  boardSettingsShowIdOnTaskCardOn = 'BoardSettings:ShowIdOnTaskCardOn',
  boardSettingsShowIdOnTaskCardOff = 'BoardSettings:ShowIdOnTaskCardOff',

  boardSettingsTurnOnTimetrackingStickerOnTheBoard = 'BoardSettings:TurnOnTimetrackingStickerOnTheBoard',

  boardSettingsClickOnCloseInExtensionsBanner = 'BoardSettings:ClickOnCloseInExtensionsBanner',
  boardSettingsClickOnOpenExtensionsInBanner = 'BoardSettings:ClickOnOpenExtensionsInBanner',
  boardSettingsClickOnAllExtensions = 'BoardSettings:ClickOnAllExtensions',
  boardSettingsClickOnAddExtensions = 'BoardSettings:ClickOnAddExtensions',

  timetrackingSetTheEstimationValueOnTimetrackingSticker = 'Timetracking:SetTheEstimationValueOnTimetrackingSticker',
  timetrackingSetTheSpentTimeValueOnTimetrackingSticker = 'Timetracking:SetTheSpentTimeValueOnTimetrackingSticker',
  timetrackingUnpin = 'Timetracking:Unpin',

  myCompanyClickOnInvitationByEmailButton = 'MyCompany:ClickOnInvitationByEmailButton',
  myCompanyCompanyMembersClickOnInviteUsers = 'MyCompany:CompanyMembersClickOnInviteUsers',
  myCompanyClickOnCopyLink = 'MyCompany:ClickOnCopyLink',
  myCompanyClickOnExtensions = 'MyCompany:ClickOnExtensions',
  boardClickOnAvatarDeckInHeader = 'Board:ClickOnAvatarDeckInHeader',
  projectRoleManagementPopupInviteByEmailInputActivation = 'ProjectRoleManagementPopup:InviteByEmailInputActivation',
  projectRoleManagementPopupInviteButtonActivation = 'ProjectRoleManagementPopup:InviteButtonActivation',
  userInvitationPopupInviteRoleSetupExpansion = 'UserInvitationPopup:InviteRoleSetupExpansion',
  userInvitationPopupClickOnSendEmailInvitationsButton = 'UserInvitationPopup:ClickOnSendEmailInvitationsButton',

  profileUnsplashReachLimitPerUser = 'Profile:UnsplashReachLimitPerUser',
  profileUnsplashHasAnotherError = 'Profile:UnsplashHasAnotherError',
  profileNotificationsSettingsChange = 'Profile:NotificationsSettingsChange',
  profileClickOnDownloadAndroidButton = 'Profile:ClickOnDownloadAndroidButton',
  profileClickOnDownloadAppleButton = 'Profile:ClickOnDownloadAppleButton',
  profileClickOnDownloadAppGalleryButton = 'Profile:ClickOnDownloadAppGalleryButton',
  boardSettingsUnsplashReachLimitPerUser = 'BoardSettings:UnsplashReachLimitPerUser',
  boardSettingsUnsplashHasAnotherError = 'BoardSettings:UnsplashHasAnotherError',

  copyTaskLinkBoard = 'CopyTaskLink:Board',
  copyTaskLinkRightPanel = 'CopyTaskLink:RightPanel',
  searchBuildIndex = 'Search:BuildIndex',

  viewSwitchToTheBoardView = 'View:SwitchToTheBoardView',
  viewSwitchToTheGanttChartView = 'View:SwitchToTheGanttChartView',
  viewSwitchToTheCalendarView = 'View:SwitchToTheCalendarView',
  viewSwitchToTheCrmAnalytics = 'View:SwitchToTheCrmAnalytics',
  viewSwitchToTheCrmActivity = 'View:SwitchToTheCrmActivity',
  viewSwitchToTheCrmFunnel = 'View:SwitchToTheCrmFunnel',

  ganttCreateTaskViaGanttChart = 'Gantt:CreateTaskViaGanttChart',
  ganttCreateSubtaskViaGanttChart = 'Gantt:CreateSubtaskViaGanttChart',
  ganttSetDeadlineFirstTime = 'Gantt:SetDeadlineFirstTime',
  ganttChangeDeadlineViaGanttChartTaskList = 'Gantt:ChangeDeadlineViaGanttChartTaskList',
  ganttChangeDeadlineViaGanttChartView = 'Gantt:ChangeDeadlineViaGanttChartView',

  ganttCreateColumnViaGanttChart = 'Gantt:CreateColumnViaGanttChart',
  ganttCompleteTaskViaGanttChart = 'Gantt:CompleteTaskViaGanttChart',
  ganttIncompleteTaskViaGanttChart = 'Gantt:IncompleteTaskViaGanttChart',
  ganttDeleteTaskViaGanttChart = 'Gantt:DeleteTaskViaGanttChart',
  ganttChangeScaleOfGanttChart = 'Gantt:ChangeScaleOfGanttChart',
  ganttChangeTheOrderOfTasksViaGanttChartTaskList = 'Gantt:ChangeTheOrderOfTasksViaGanttChartTaskList',
  ganttChangeTheOrderOfColumnsViaGanttChartTaskList = 'Gantt:ChangeTheOrderOfColumnsViaGanttChartTaskList',

  ganttCreateDependencyViaGanttChart = 'Gantt:CreateDependencyViaGanttChart',
  ganttDeleteDependencyViaGanttChart = 'Gantt:DeleteDependencyViaGanttChart',
  ganttDeleteDependencyViaRightPanel = 'Gantt:DeleteDependencyViaRightPanel',
  ganttEnableAutoPlanning = 'Gantt:EnableAutoPlanning',
  ganttDisableAutoPlanning = 'Gantt:DisableAutoPlanning',

  companyLinkOpeningOfTheRegistrationConfirmationPopup = 'CompanyLink:OpeningOfTheRegistrationConfirmationPopup',
  companyLinkClosingOfTheRegistrationConfirmationPopup = 'CompanyLink:ClosingOfTheRegistrationConfirmationPopup',
  companyLinkRejectUserRegistrationViaPopup = 'CompanyLink:RejectUserRegistrationViaPopup',
  companyLinkConfirmUserRegistrationViaPopup = 'CompanyLink:ConfirmUserRegistrationViaPopup',
  companyLinkConfirmUserRegistrationViaUserList = 'CompanyLink:ConfirmUserRegistrationViaUserList',
  companyLinkRejectUserRegistrationViaUserList = 'CompanyLink:RejectUserRegistrationViaUserList',

  newsPopupShowed = 'NewsPopup:Showed',
  newsPopupClosed = 'NewsPopup:Closed',
  newsPopupClickOnButtonSeeAllNews = 'NewsPopup:ClickOnButtonSeeAllNews',
  newsPopupClickOnButtonSeeAllComments = 'NewsPopup:ClickOnButtonSeeAllComments',

  googleCalendarSuccessGoogleIntegrationPopup = 'GoogleCalendar:SuccessGoogleIntegrationPopup',
  googleCalendarClickOnDisableGoogleIntegrationButtonInSettingsPopup = 'GoogleCalendar:ClickOnDisableGoogleIntegrationButtonInSettingsPopup',

  extensionsRateExtensionInList = 'Extensions:RateExtensionInList',
  extensionsRateExtensionInDetails = 'Extensions:RateExtensionInDetails',
  extensionsClickOnExtensionCommentsLink = 'Extensions:ClickOnExtensionCommentsLink',
  extensionsClickOnExtensionTitle = 'Extensions:ClickOnExtensionTitle',
  extensionsClickOnMediaInList = 'Extensions:ClickOnMediaInList',
  extensionsClickOnMediaInDetails = 'Extensions:ClickOnMediaInDetails',
  extensionsClickOnFilter = 'Extensions:ClickOnFilter',
  extensionsFocusOnSearch = 'Extensions:FocusOnSearch',
  extensionsOnSortingChanged = 'Extensions:OnSortingChanged',

  extensionsClickOnExtensionIsListTagDeadClick = 'Extensions:ClickOnExtensionIsListTagDeadClick',
  extensionsClickOnExtensionIsListDescriptionDeadClick = 'Extensions:ClickOnExtensionIsListDescriptionDeadClick',

  platformTestEvent = 'Platform:TestEvent',

  crmClickOnAddCrmProjectButton = 'Crm:ClickOnAddCrmProjectButton',
  crmClickOnAddCrmProjectButtonInDropdown = 'Crm:ClickOnAddCrmProjectButtonInDropdown',
  crmClickOnCreateCrmProjectInPopupForm = 'Crm:ClickOnCreateCrmProjectInPopupForm',
  crmBoardCreate = 'Crm:BoardCreate',

  // ExtensionUsage is busy by extensions DAU
  // Important: not use 'ExtensionUsage' category for another goals
  extensionUsageEvent = 'ExtensionUsage:Event'
}

export type LeftAndTopPanelTheme =
  | 'gray'
  | 'adaptiveAuto'
  | 'adaptiveLight'
  | 'adaptiveDark'

export interface AmplitudeUserProps {
  leftMenuState?: 'collapsed' | 'expanded'
  lang?: Language
  theme?: UserUITheme
  leftAndTopPanelTheme?: LeftAndTopPanelTheme
  userId?: DataObjectId
  rightPanelWidth?: string
  rightPanelWidthResize?: string
  screenHeight?: string
  screenWidth?: string
  browser?: string
  web_os?: string
  platform?: 'web' | 'desktop' | 'mobile'
  hostname?: string
}
